import React, { useState } from "react";
import styles from "./Summary.module.css";
import HeadingAndDropDown from "../../components/HeadingAndDropDown/HeadingAndDropDown";

const dummyQuestions = [
  { label: "Parent Upload", value: "parentUpload" },
  { label: "Student Photo", value: "studentPhoto" },
  { label: "Aadhar Upload", value: "aadharUpload" },
];
  

const Summary = () => {
    const [selectedQuestion, setSelectedQuestion] = useState("");


  return (
    <div className={styles.container}>
      <div className={styles.boxWrapper}>
        <div className={styles.questionBox}>
          <div className={styles.questionTitle}>
            <HeadingAndDropDown
              label="Form question"
              name="formQuestion"
              value={selectedQuestion}
              onChange={(e) => setSelectedQuestion(e.target.value)}
              options={dummyQuestions}
              placeholder="Select Form Question"
            />
          </div>
        </div>

        <div className={styles.responseBox}>
          <div className={styles.responseTitle}>
            {getLabel(selectedQuestion)}
          </div>
          <div className={styles.responseCount}>
            Total responses : <span>0</span>
          </div>
        </div>
      </div>
    </div>
  );
};

const getLabel = (value) => {
  const match = dummyQuestions.find((q) => q.value === value);
  return match ? match.label : "";
};

export default Summary;
